module.exports = __webpack_public_path__ + "static/media/key.763e6517.svg";